import { Box, Typography, Tooltip } from '@mui/material';
import type { GridSortModel } from '@mui/x-data-grid-pro';

export const SortIcon = ({ direction, isActive }: { direction?: 'asc' | 'desc' | null; isActive?: boolean }) => {
    const activeColor = '#14803C';
    const inactiveColor = '#808080';

    const topArrowColor = direction === 'asc' && isActive ? activeColor : inactiveColor;
    const bottomArrowColor = direction === 'desc' && isActive ? activeColor : inactiveColor;

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.0003 10.6665L11.3337 13.3332L8.66699 10.6665" stroke={bottomArrowColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11.333 13.3332V2.6665" stroke={bottomArrowColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2 5.33317L4.66667 2.6665L7.33333 5.33317" stroke={topArrowColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M4.66699 2.6665V13.3332" stroke={topArrowColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

// Factory function to create renderColumnHeader with sortModel from state
export const createRenderColumnHeader = (sortModel: GridSortModel) => (params: any) => {
    const sortItem = sortModel.find((item) => item.field === params.field);
    const sortDirection = sortItem?.sort as 'asc' | 'desc' | null | undefined;
    const isActive = !!sortDirection;

    
    const getTooltipText = () => {
        if (sortDirection === 'asc') return 'Click to sort Descending';
        if (sortDirection === 'desc') return 'Click to clear sort';
        return 'Click to sort Ascending';
    };
    
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%', cursor: 'pointer' }}>
            <Typography variant="subtitle1" component="span" sx={{
                fontWeight: 700,
                fontSize: '14px',
                lineHeight: '20px',
                letterSpacing: '-0.15px',
                color: '#0A0A0A',
                display: 'inline-flex',
                alignItems: 'center',
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                overflow: 'hidden',
            }}>
                {params.colDef.headerName}
                {  params?.colDef?.sortable && <Tooltip title={getTooltipText()} arrow placement="top" sx={{fontWeight: 400, fontSize: '10px', color: '#FFFFFF', height: '13px', width: '154px'}}>
                    <Box component="span" className="custom-sort-icon" sx={{ display: 'inline-flex', alignItems: 'center', ml: 0.5, flexShrink: 0 }}>
                        <SortIcon direction={sortDirection} isActive={isActive} />
                    </Box>
                </Tooltip> }
            </Typography>
        </Box>
    );
};

// Default renderColumnHeader that uses grid API state (for backwards compatibility)
export const renderColumnHeader = (params: any) => {
    const sortModel = params.api?.state?.sorting?.sortModel || [];
    const sortItem = sortModel.find((item: any) => item.field === params.field);
    const sortDirection = sortItem?.sort as 'asc' | 'desc' | null | undefined;
    const isActive = !!sortDirection;
    
    const getTooltipText = () => {
        if (sortDirection === 'asc') return 'Click to sort Descending';
        if (sortDirection === 'desc') return 'Click to clear sort';
        return 'Click to sort Ascending';
    };
    
    return (
        <Tooltip title={getTooltipText()} arrow>
            <Box sx={{ display: 'flex', alignItems: 'center', height: '100%', cursor: 'pointer' }}>
                <Typography variant="subtitle1" component="span" sx={{ 
                    fontWeight: 600,
                    fontSize: '16px',
                    lineHeight: '24px',
                    letterSpacing: '-0.31px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    overflow: 'hidden',
                }}>
                    {params.colDef.headerName}
                    <Box component="span" className="custom-sort-icon" sx={{ display: 'inline-flex', alignItems: 'center', ml: 0.5, flexShrink: 0 }}>
                        <SortIcon direction={sortDirection} isActive={isActive} />
                    </Box>
                </Typography>
            </Box>
        </Tooltip>
    );
};
